import { useMemo } from "react";
import { createPublicClient, http } from "viem";
import { baseSepolia, sepolia } from "viem/chains";
import ChainId from "../constants/chainId";
import { DEFAULT_CHAIN_ID } from "@/constants";

export const chainConfig = {
  [ChainId.BASE_SEPOLIA]: baseSepolia,
  [ChainId.SEPOLIA]: sepolia,
};

const usePublicClient = () => {
  const publicClient = useMemo(() => {
    return createPublicClient({
      chain: chainConfig[DEFAULT_CHAIN_ID],
      transport: http(),
    });
  }, []);

  return publicClient;
};

export default usePublicClient;
